module.exports = __webpack_public_path__ + "static/media/loading.ebc06700.svg";


//////////////////
// WEBPACK FOOTER
// ./src/media/img/loading.svg
// module id = 147
// module chunks = 221